/**
 * Greaseproof Advanced Customizer Engine
 * Powered by Fabric.js
 */

class GreaseproofCustomizer {
    constructor() {
        this.canvas = null;
        this.logo = null;
        this.originalLogo = null;
        this.config = {
            pattern: 'FullDrop',
            scale: 0.50,
            spacing: 20,
            rotation: 0,
            offsetX: 0,
            offsetY: 0,
            paperWidth: 300, 
            paperHeight: 200
        };

        this.init();
    }

    async init() {
        // Wait for Fabric.js to be available
        if (typeof fabric === 'undefined') {
            await this.loadFabric();
        }

        this.setupCanvas();
        this.bindEvents();
        console.log('Greaseproof Customizer Initialized');
    }

    loadFabric() {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1/fabric.min.js';
            script.onload = resolve;
            document.head.appendChild(script);
        });
    }

    setupCanvas() {
        const canvasEl = document.getElementById('customizer-canvas');
        if (!canvasEl) return;

        this.canvas = new fabric.StaticCanvas('customizer-canvas', {
            backgroundColor: '#ffffff',
            selection: false
        });

        this.resizeToFit();
    }

    resizeToFit() {
        const container = document.getElementById('customizer-canvas-container');
        if (!container || !this.canvas) return;

        const width = container.clientWidth;
        const height = container.clientHeight;

        this.canvas.setDimensions({ width, height });
        this.updatePattern();
    }

    bindEvents() {
        // Tab Switching
        document.querySelectorAll('.customizer-tab').forEach(tab => {
            tab.addEventListener('click', (e) => this.switchTab(e.target.dataset.tab));
        });

        // Pattern Selection
        document.querySelectorAll('.pattern-template').forEach(tpl => {
            tpl.addEventListener('click', (e) => {
                const target = e.currentTarget;
                document.querySelectorAll('.pattern-template').forEach(t => t.classList.remove('active'));
                target.classList.add('active');
                this.config.pattern = target.dataset.pattern;
                this.updatePattern();
            });
        });

        // Sliders
        const scaleSlider = document.getElementById('customizer-scale');
        if (scaleSlider) {
            scaleSlider.addEventListener('input', (e) => {
                this.config.scale = parseFloat(e.target.value) / 100;
                this.updatePattern();
                document.getElementById('scale-value').textContent = e.target.value + '%';
            });
        }

        // Arrow Buttons
        document.querySelectorAll('.arrow-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const dir = btn.dataset.dir;
                const step = 5;
                if (dir === 'up') this.config.offsetY -= step;
                if (dir === 'down') this.config.offsetY += step;
                if (dir === 'left') this.config.offsetX -= step;
                if (dir === 'right') this.config.offsetX += step;
                this.updatePattern();
            });
        });

        // Spacing Buttons
        document.getElementById('spacing-plus')?.addEventListener('click', () => {
            this.config.spacing += 2;
            this.updatePattern();
        });
        document.getElementById('spacing-minus')?.addEventListener('click', () => {
            this.config.spacing = Math.max(0, this.config.spacing - 2);
            this.updatePattern();
        });

        // File Handler Sync (from existing file logic)
        document.addEventListener('design:fileUploaded', (e) => {
            this.loadLogo(e.detail.file);
        });
        document.addEventListener('design:fileCleared', () => {
            this.logo = null;
            if (this.canvas) {
                this.canvas.clear();
                this.canvas.backgroundColor = '#ffffff';
                this.canvas.renderAll();
            }
            const ph = document.getElementById('canvas-placeholder');
            if (ph) ph.style.display = 'flex';
        });
    }

    switchTab(tabId) {
        document.querySelectorAll('.customizer-tab').forEach(t => t.classList.remove('active'));
        document.querySelector(`.customizer-tab[data-tab="${tabId}"]`).classList.add('active');

        const controls = document.querySelector('.customizer-controls');
        const quote = document.getElementById('quick-quote-content');
        const gallery = document.querySelector('.product__media-gallery') || document.querySelector('media-gallery');
        const canvasCont = document.getElementById('customizer-canvas-container');

        if (tabId === 'personalize') {
            controls.classList.add('active');
            quote.style.display = 'none';
            if (gallery) gallery.style.display = 'none';
            canvasCont.classList.add('active');
            // Defer resize so container has dimensions after becoming visible
            requestAnimationFrame(() => {
                this.resizeToFit();
                const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
                if (fileInput && fileInput.files && fileInput.files.length > 0 && fileInput.files[0].type.startsWith('image/')) {
                    this.loadLogo(fileInput.files[0]);
                }
            });
        } else {
            controls.classList.remove('active');
            quote.style.display = 'block';
            if (gallery) gallery.style.display = 'block';
            canvasCont.classList.remove('active');
        }
    }

    loadLogo(file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const isSvg = file.type === 'image/svg+xml' || (typeof data === 'string' && data.startsWith('data:image/svg+xml'));
            if (isSvg && typeof fabric.loadSVGFromURL === 'function') {
                fabric.loadSVGFromURL(data, (objects, options) => {
                    const group = fabric.util.groupSVGElements(objects, options);
                    if (group) {
                        this.logo = group;
                        this.logo.set({ originX: 'center', originY: 'center', selectable: false });
                        this.hidePlaceholder();
                        this.updatePattern();
                    } else {
                        this.tryImageFallback(data);
                    }
                });
            } else {
                this.tryImageFallback(data);
            }
        };
        reader.readAsDataURL(file);
    }

    tryImageFallback(data) {
        fabric.Image.fromURL(data, (img) => {
            if (img) {
                this.logo = img;
                this.logo.set({ originX: 'center', originY: 'center', selectable: false });
                this.updatePattern();
                this.hidePlaceholder();
            }
        }, { crossOrigin: 'anonymous' });
    }

    hidePlaceholder() {
        const ph = document.getElementById('canvas-placeholder');
        if (ph) ph.style.display = 'none';
    }

    showPlaceholder() {
        const ph = document.getElementById('canvas-placeholder');
        if (ph) ph.style.display = 'flex';
    }

    updatePattern() {
        if (!this.canvas || !this.logo) return;

        // Use requestAnimationFrame for smoother rendering
        requestAnimationFrame(() => {
            this.canvas.clear();
            this.canvas.backgroundColor = '#ffffff';

            const logoWidth = this.logo.width * this.config.scale;
            const logoHeight = this.logo.height * this.config.scale;
            const spacingX = logoWidth + this.config.spacing;
            const spacingY = logoHeight + this.config.spacing;

            const cw = this.canvas.width;
            const ch = this.canvas.height;

            const positions = [];
            
            // Limit iterations to prevent freezing on extremely small scales
            const maxIter = 1000;
            let iter = 0;

            for (let x = -logoWidth; x < cw + logoWidth && iter < maxIter; x += spacingX) {
                for (let y = -logoHeight; y < ch + logoHeight && iter < maxIter; y += spacingY) {
                    iter++;
                    let currentX = x + this.config.offsetX;
                    let currentY = y + this.config.offsetY;

                    if (this.config.pattern === 'HalfDrop' && (Math.round(x / spacingX) % 2 !== 0)) {
                        currentY += spacingY / 2;
                    }
                    if (this.config.pattern === 'Brick' && (Math.round(y / spacingY) % 2 !== 0)) {
                        currentX += spacingX / 2;
                    }

                    let scaleX = this.config.scale;
                    let scaleY = this.config.scale;
                    if (this.config.pattern === 'Mirror') {
                        if (Math.round(x / spacingX) % 2 !== 0) scaleX *= -1;
                        if (Math.round(y / spacingY) % 2 !== 0) scaleY *= -1;
                    }

                    positions.push({ currentX, currentY, scaleX, scaleY });
                    if (this.config.pattern === 'NoRepeat') break;
                }
                if (this.config.pattern === 'NoRepeat') break;
            }

            let pending = positions.length;
            if (pending === 0) {
                this.canvas.renderAll();
                return;
            }

            const done = () => {
                pending--;
                if (pending === 0) this.canvas.renderAll();
            };

            positions.forEach(({ currentX, currentY, scaleX, scaleY }) => {
                this.logo.clone((cloned) => {
                    if (!cloned) { done(); return; }
                    cloned.set({
                        left: currentX,
                        top: currentY,
                        scaleX: scaleX,
                        scaleY: scaleY,
                        angle: this.config.rotation,
                        selectable: false,
                        evented: false,
                        originX: 'center',
                        originY: 'center'
                    });
                    this.canvas.add(cloned);
                    done();
                });
            });
        });
    }

    // Export current config as JSON for cart properties
    exportConfig() {
        return JSON.stringify(this.config);
    }

    // Export canvas as PNG blob for Customized Preview line item property
    exportCanvasAsPngBlob() {
        return new Promise((resolve) => {
            if (!this.canvas || !this.logo) {
                resolve(null);
                return;
            }
            try {
                const dataUrl = this.canvas.toDataURL({ format: 'png', multiplier: 2 });
                if (!dataUrl || dataUrl === 'data:,') { resolve(null); return; }
                fetch(dataUrl).then(r => r.blob()).then(resolve).catch(() => resolve(null));
            } catch (e) {
                resolve(null);
            }
        });
    }
}

// Initialize when DOM ready
document.addEventListener('DOMContentLoaded', () => {
    window.GreaseproofCustomizer = new GreaseproofCustomizer();
});
